import React from "react";

import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ThankYouComponent = ({ message }) => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate(-1);
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
      onClick={handleNavigation}
    >
      {/* <CheckCircleIcon
        sx={{
          fontSize: "70px !important",
          marginBottom: 2,
          color: "var(--aqua-1) !important",
        }}
      /> */}
      <Box
        component="img"
        src="/icons/Zuno star mobile app icon-06.png"
        alt="Icon"
        className="thank-you-icon"
        onClick={handleNavigation}
      />

      <Typography variant="h6" className="typography_heading thank_you_message">
        {message}
      </Typography>
    </Box>
  );
};

export default ThankYouComponent;
